import { useState } from "react";
import { ImgDown } from "./Images/ImgDown";
import { ImgUp } from "./Images/ImgUp";
import { ThinkingIndicator } from "./ThinkingIndicator";

export const CollapsibleThink: React.FC<{ children: React.ReactNode, text: string, className?: string, additionalContent?: React.ReactNode, isAnimating?: boolean }> = ({ children, text, className, additionalContent, isAnimating }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`think-block ${className ?? ''} ${open ? 'open' : ''}`}>
      <button onClick={() => setOpen(!open)} className="think-toggle">
        {isAnimating && <ThinkingIndicator>{text}</ThinkingIndicator>}
        {!isAnimating && <>{text}</>}
        {open ? <ImgUp /> : <ImgDown />} {additionalContent}
      </button>
      {open && <div className="think-content">{children}</div>}
    </div>
  );
};